import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Form, Modal, Icon } from "semantic-ui-react";
import { useForm } from "react-hook-form";

//Actions
import { updateDiscountPrice } from "../../redux/actions/reservations/space/updateDiscountPrice";

export default function ChangeStateRateModal(props) {
  const sixDotTwoRegex = new RegExp(/^\d{0,6}(\.\d{0,2})?$/);
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false)
  const { register, handleSubmit, errors, getValues } = useForm();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(updateDiscountPrice(props.stateSpace.id, data));
  };

  return (
    <>
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={ props.stateSpace.special_discount_price == 0.00 ? 
          <Button className="add_button" icon circular size="mini"> 
            <Icon className="icon_color" name="add" />
          </Button> 
          : 
          <div className="text-[#1261a0] cursor-pointer font-semibold">
            <p>- {props.stateSpace.special_discount_price}</p>
          </div> 
          }
      >
        <Modal.Header>
          { t("aditional_discount") }
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group>
                <Form.Field className="flex gap-5 w-full">
                  <label className="w-[16%]"> { t("total_label")}:</label>
                  <label>$ {parseFloat(props.stateSpace.price) + parseFloat(props.stateSpace.flight_price) - parseFloat(props.stateSpace.commission_price) - parseFloat(props.stateSpace.special_discount_price)}  </label>
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <Form.Field className="flex gap-3 w-full items-center" required>
                  <label className="w-[20%]">{ t("discount_value") }:</label>
                  <div className="w-full flex flex-col">
                    <input name="special_discount_price" defaultValue={props.stateSpace.special_discount_price == 0.00 ? "" : props.stateSpace.special_discount_price } ref={register({pattern: sixDotTwoRegex,required: true})} />
                    {errors.special_discount_price && (<span className="error_message">{t("valid_number")}</span>)}
                  </div>
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field className="flex gap-3 items-center w-full" required>
                  <label className="w-[20%]">{ t("description") }:</label>
                  <div className="w-full flex flex-col">
                    <input name="special_discount_description" defaultValue={props.stateSpace.special_discount_description} ref={register({required: true})} />
                    {errors.special_discount_description && (<span className="error_message">{t("required_information")}</span>)}
                  </div>   
                </Form.Field>
              </Form.Group>
              <Button primary type="submit" loading={props.stateSpace.processing ? true : false}>
              { t("apply_discount") }
              </Button>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>
            {t("canceled_button")}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );

}